var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CoursesEnciteItem', {
    attrs: {
      "pageTitle": 'Online Courses FOCI',
      "courseTitle": 'FOCI',
      "courseFullTitle": 'Understanding Foreign Ownership, Control, or Influence (FOCI)',
      "informationCardColor": '#000',
      "courseItems": _vm.items
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }